<template lang='pug'>
  #about.view
    section
      wrapper.max-800
        h1 About The DigiNomix Blog
        p
          | DigiNomix is a lifestyle and professional blog for digital nomads and global citizens
          | particularly software developers & engineers, UI/UX designers, internet marketers,
          | and others who work remotely in the digital economy

        ul
          li
            h2 Topics Covered
          
          divider.borderless.card

          li
            h3 Front-End Development:  HTML5, CSS3, JavaScript (ES6+), VueJS
          
          divider.borderless.card

          li
            h3 JAMstack
          
          divider.borderless.card

          li
            h3 API's (Application Programming Interfaces)
          
          divider.borderless.card

          li
            h3 Digital Marketing:  Content Marketing, SEO, Social Media
          
          divider.borderless.card

          li
            h3 Tech Entrepreneurship
          
          divider.borderless.card

          li
            h3 Health, Travel, and Living
            p 
              | There are specific challenges to working in front of the desk all day and health hazards unique to this type of profession.
              //- | Add to that constant travel to far away lands and we can end up dead.
              //- | Ok so many not dead but certainly unhealthy
    
    divider.on-light.section

    section
      wrapper.max-800
        h1 About The Main Author
        p
          | I'm Jovi, the creator of this blog.  After two decades of being involved in a multitude of in tech startups, 
          | I need to get some things off my chest.  
          | Hopefully my experience can help others
          | There are too many mistakes as a result of misinformation out there - 
          | Too many myths on the glamour of entrepreneurship.
          | I had to learn the hard way
          | I'm always interested in meeting likeminded inviduals.  So feel free to mail me at
          a( href='mailto:jovi@diginomix.co' ) jovi@diginomix.co

        p
          | Born and raised in Cali.  
          | I worked in the Silicon Valley for most of my life - though now I'm based out of Singapore.
          | That said, I consider myself a Global Citizen.
          | I am a team player and someone who is honest and owns up to my mistakes. 
          | I welcome feedback and focus on fixing problems. 
          | I believe in putting in effort to perfect one's craft and enjoy working with other people who share a similar mindset - who don't need a manager for motivation and uphold high standards
</template>

<script>
  import Wrapper from '@/components/containers/wrapper'
  import Divider from '@/components/containers/divider'

  export default {
    name: 'about',

    components: {
      Wrapper,
      Divider
    },

    metaInfo: {
      titleTemplate: 'DigiNomix | %s',
      title: 'SEO Friendly High Performance Progressive Web Apps',

      meta: [
        { key: 'description', name: 'description', content: 'SEO Friendly High Performance Progressive Web Apps using modern JAMstack with Static Site Generators'},
        { key: 'theme-color', name: 'theme-color', content: '#64a7ad' }
      ],

      link: [
        { rel: 'manifest', href: 'manifest.json' }
      ]
    }
  }
</script>

<style scoped lang='stylus'>
  #about
    p
      line-height 1.75

  section
    padding 1.6vh 6.4vw
    line-height 1.75

  ul li
    margin 32px 0

  h1, h2, p
    padding .5em 0

  h3
    // font-style italic
    font-size 1.25em
    font-family 'Open Sans Condensed'
    letter-spacing .5px
    // border-bottom 1px dotted rgba( 0 0 0 .1 )
    // border-top 1px dotted rgba( 0 0 0 .1 )
</style>
